<template>
  <div>
    <Loading :loading="this.loading"></Loading>
    <div v-show="!this.loading" v-if="isInitialAgreement">
      <div class="content-wrapper">
        <div class="container">
          <article>
            <section class="section white-panel pr0 mb2p">
              <div class="mr16">
                <h2 class="text-center fs15 font-weight-bold mb16">洗車プリペイドの<br>
    利用規約をご確認の上、<br>
    残高をチャージしてください</h2>
              <p class="color-red2 font-weight-bold fs14 text-center">ご利用店舗：{{ssInfo.ss_name}}</p>
              <div class="bg-gray1 pd12 mt20 mb20">
                <p class="mb8 fs14"><strong>特に下記の点にご注意ください</strong></p>
                <ul class="fs14 line-height1_7 ul-disc-blue pl20">
                  <li>残高の有効期限はチャージから180日です</li>
                  <li>上記ご利用店舗でのみ使えます</li>
                  <li>払い戻しはできません</li>
                </ul>
              </div>
              <button class="button button-gray fs16 mb12" v-on:click="toAgreement()">利用規約</button>
              <button class="button fs16 mt8 mb4 pd16 radius200" v-on:click="toChargeFromInitialAgreement()">上記に同意して次へ</button>
              </div>
            </section>
          </article>
        </div>

        <input id="tsid" type="hidden" name="tsid" v-bind:value="nativeData.tsid">
        <input id="otoken" type="hidden" name="otoken" v-bind:value="nativeData.otoken">
        <input id="popinfoid" type="hidden" name="popinfoid" v-bind:value="nativeData.popinfoid">
        <input id="authid" type="hidden" name="authid" v-bind:value="nativeData.authid">
        <input id="ss_code" type="hidden" name="ss_code" v-bind:value="nativeData.ss_code">
        <input id="card_no" type="hidden" name="card_no" v-bind:value="nativeData.card_no">
        <input id="pin_cd" type="hidden" name="pin_cd" v-bind:value="nativeData.pin_cd">
      </div>
    </div>
    <div v-else-if="isAgreement">
      <a id="isAgreement" v-on:click="toInitialAgreement()"></a>
      <Agreement></Agreement>
    </div>
  </div>
</template>

<script>
import Agreement from '@/views/v1/Agreement.vue'
import ssApi from '@/store/Api/ss'
import modal from '@/assets/v1/modal'
import Loading from '@/views/v1/Loading'

const IS_INITIAL_AGREEMENT = 'IS_INITIAL_AGREEMENT'
const IS_AGREEMENT = 'IS_AGREEMENT'

export default {
  data () {
    return {
      loading: true,
      ssInfo: [],
      currentState: IS_INITIAL_AGREEMENT
    }
  },
  computed: {
    isInitialAgreement () {
      return this.currentState === IS_INITIAL_AGREEMENT
    },
    isAgreement () {
      return this.currentState === IS_AGREEMENT
    },
    nativeData: function () {
      const getData = {}
      // ネイティブから取得したクエリパラメータを格納する。
      getData.tsid = this.$route.query.tsid
      getData.popinfoid = this.$route.query.popinfoid
      getData.otoken = this.$route.query.otoken
      getData.authid = this.$route.query.authid
      getData.ss_code = this.$route.query.ss_code
      getData.card_no = this.$route.query.card_no
      getData.pin_cd = this.$route.query.pin_cd
      return getData
    }
  },
  methods: {
    toInitialAgreement () {
      this.currentState = IS_INITIAL_AGREEMENT
    },
    toAgreement () {
      // [eventTrack]
      this.nativeEVENTSet('CarWashSyokaiRiyouButton', 'MOVED_RIYOU_KIYAKU', 'TAP')
      this.currentState = IS_AGREEMENT
    },
    setSsInfo (ssInfo) {
      this.ssInfo = ssInfo
    },
    openErrorModal (message) {
      modal.alert(message)
    },
    // [初回利用規約画面]上記に同意して次へボタン
    toChargeFromInitialAgreement () {
      // [eventTrack]
      this.nativeEVENTSet('CarWashSyokaiRiyouButton', 'MOVED_CHARGE', 'TAP')
      // チャージ画面へ遷移
      this.toCharge()
    },
    toCharge () {
      // チャージ画面へ遷移
      this.$router.push({
        name: 'V1Charge',
        query: {
          tsid: this.nativeData.tsid,
          otoken: this.nativeData.otoken,
          popinfoid: this.nativeData.popinfoid,
          authid: this.nativeData.authid,
          ss_code: this.nativeData.ss_code,
          card_no: this.nativeData.card_no,
          pin_cd: this.nativeData.pin_cd
        }
      })
    }
  },
  async mounted () {
    // 戻るボタンの出し分け
    this.appDisplayBack(true)

    let isApiError = false

    // SS
    await ssApi.get(this.nativeData.ss_code).then(res => {
      this.setSsInfo(res.data.body.ss_info)
    }).catch(e => {
      console.log('ss-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    // [eventTrack]
    this.nativePVset('CARWASH_SYOKAI_RIYOUKIYAKU')

    if (!isApiError) {
      this.loading = false
    }
  },
  components: {
    Loading,
    Agreement
  }
}
</script>
